/*
 * Homepage carousels (2026-10-05): best sellers, shop by goal, experts.
 * One scroller pattern: a scroll-snap track, prev/next arrows, and an
 * optional progress readout ("01 02 03" + bar). No library.
 */
(function () {
  function init(root) {
    var track = root.querySelector('[data-yt-track-el]');
    if (!track) return;
    var prev = root.querySelector('[data-yt-prev]');
    var next = root.querySelector('[data-yt-next]');
    var bar = root.querySelector('[data-yt-progress-bar]');
    var pages = root.querySelector('[data-yt-pages]');
    function step() {
      var card = track.querySelector(':scope > *');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var ratio = max > 0 ? track.scrollLeft / max : 0;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (bar) bar.style.transform = 'scaleX(' + Math.max(0.12, 0.12 + ratio * 0.88) + ')';
      if (pages) {
        var n = pages.children.length;
        var idx = Math.min(n - 1, Math.round(ratio * (n - 1)));
        Array.prototype.forEach.call(pages.children, function (el, i) { el.classList.toggle('is-current', i === idx); });
      }
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  document.querySelectorAll('[data-yt-carousel]').forEach(init);
})();
